<template>
  <q-card flat :style="isDialog && !$q.screen.lt.md?'min-width:500px':''">
    <q-card-section v-if="showHeader" class="no-padding">
      <q-banner class="bg-indigo text-white" inline-actions>
        <span v-if="!customerInfo"><span>تماس با شماره </span> <b>{{ localCallNumber }}</b></span>
        <span v-if="customerInfo">تماس با <b>{{ customerInfo.Cs_Name }}</b></span>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
      <q-space/>
    </q-card-section>
    <q-card-section class="text-center">
      <q-input v-if="customCall" hide-bottom-space type="tel"
               dir="ltr"
               style="font-size: 20px"
               v-model="localCallNumber" filled label="شماره تماس"
               :rules="[
                   val=> !!val   || 'شماره تماس نامعتبر است',
                   val => val.length > 5 || 'شماره تماس نامعتبر است'
               ]"/>

      <q-btn-toggle
          clearable
          v-model="callCenter"
          no-wrap
          push
          class="q-mt-sm"
          :options="items"
      />
      <q-space/>
      <q-btn-toggle
          :disable="localCallNumber==='' || callCenter===''  || callType===''"
          clearable
          v-model="callType"
          no-caps
          no-wrap
          push
          @click="dial"
          class="q-mt-xs"
          :options="itemsType"
      />
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CallPanel",
  props: {
    customCall: {
      type: Boolean,
      default: false
    },
    callNumber: {
      type: String,
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    customerInfo: {
      type: Object,
      default: () => undefined
    },
    isDialog:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localCallNumber: this.callNumber,
      callCenter: undefined,
      callType: undefined,
      items: [
        {label: 'نوران - تهران', value: 'opt1', color: 'indigo'},
        {label: 'نوران - اهواز', value: 'opt2', color: 'indigo'},
        {label: 'صاف', value: 'opt3', color: 'indigo'},
        {label: 'نوران - تامین کنندگان', value: 'opt4', color: 'indigo'}],
      itemsType: [],
      postfix: ''
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'sendMessage',
    }),
    onReset() {

    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    sendMessageForConference(postfix, number, userPhone) {
      this.sendMessage(`${this.$store.state.internalUserMobile}&${postfix}${userPhone}&${postfix}${number}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما از طریق مرکز تماس نوران برقرار خواهد شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    },
    sendMessageForDirectCall(postfix, number) {
      this.sendMessage(`${postfix}&${number}`).then((res) => {
        if (res.msg === 'success') {
          this.$q.notify({
            type: 'positive',
            position: 'top',
            color: 'positive',
            message: 'تا لحظاتی دیگر تماس شما برقرار خواهد شد، لطفا اندکی تامل فرمایید'
          });
        } else {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset();
        }
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'ارتباط با مرکر تماس قطع است'
        });
        this.onReset()
      });
    },
    dial() {
      if (!this.callCenter || !this.callType || (!this.localCallNumber && this.customerInfo) || (!this.localCallNumber && !this.customerInfo)) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'مرکز تماس، ابزار تماس و یا شماره تماس تعیین نشده است'
        });
        return;
      }
      if (this.callCenter === 'opt1') {
        if (this.$store.state.postfixPhone2 === null) {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'پیش شماره شما برای این مرکز تعریف نشده است'
          });
          return
        } else {
          this.postfix = this.$store.state.postfixPhone2
        }
      } else if (this.callCenter === 'opt2') {
        if (this.$store.state.postfixPhone1 === null) {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'پیش شماره شما برای این مرکز تعریف نشده است'
          });
          return
        } else {
          this.postfix = this.$store.state.postfixPhone1
        }
      } else if (this.callCenter === 'opt3') {
        if (this.$store.state.postfixPhone2 === null) {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'پیش شماره شما برای این مرکز تعریف نشده است'
          });
          return
        } else {
          this.postfix = this.$store.state.postfixPhone3
        }
      }else if (this.callCenter === 'opt4') {
        this.postfix = "*897"
      }
      if (this.callType === 'conference-mobile') {
        this.sendMessageForConference(this.postfix, this.localCallNumber, this.$store.state.userMobile)
      } else if (this.callType === 'conference-phone') {
        this.sendMessageForConference(this.postfix, this.localCallNumber, this.$store.state.phone)
      } else {
        this.sendMessageForDirectCall(`${this.$store.state.avayaExt}`, `${this.postfix}${this.localCallNumber}`)
      }
    }
  },
  created() {
    if (this.$store.state.internalUserMobile && this.$store.state.internalUserMobile !== '') {
      if (this.$store.state.userMobile && this.$store.state.userMobile !== '') {
        this.itemsType.push({label: 'موبایل', value: 'conference-mobile', color: 'indigo'})
      }
      if (this.$store.state.phone && this.$store.state.phone !== '') {
        this.itemsType.push({label: 'تلفن ثابت', value: 'conference-phone', color: 'indigo'})
      }
      if (this.$store.state.avayaExt && this.$store.state.avayaExt !== '') {
        this.itemsType.push({label: 'تلفن ثابت داخلی', value: 'direct', color: 'indigo'})
      }
    }

    if (this.customerInfo !== undefined) {
      switch (this.customerInfo.CompID) {
        case 1:
          this.callCenter = this.items.filter(item => item.value === "opt2")[0]
          break;
        case 2:
          this.callCenter = this.items.filter(item => item.value === "opt3")[0]
          break;
        case 3:
          this.callCenter = this.items.filter(item => item.value === "opt2")[0]
          break;
        case 4:
          this.callCenter = this.items.filter(item => item.value === "opt2")[0]
          break;
        case 5:
          this.callCenter = this.items.filter(item => item.value === "opt2")[0]
          break;
        default:
          this.callCenter = this.items.filter(item => item.value === "opt3")[0]
          break;
      }
      this.callType = this.itemsType.filter(item => item.value === "direct")[0]
    }
  }
}
</script>

<style scoped>

</style>